import styled from 'styled-components';

const BulletListContainer = styled.ul`
  display: flex;
  margin-left: 32px;
  padding: 0px;
  gap: 6px;

  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* Body/X-Large/xl-regular */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 27px */
`;

const BulletListItem = styled.li`
  ::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 4px;

    margin-left: -12px;
    margin-top: 10px;

    border-radius: var(--radius-round, 80px);
    background: var(--Light-Scheme-Monochrome-grey50, #babdca);
  }
`;

export { BulletListContainer, BulletListItem };
